module.exports = __webpack_public_path__ + "img/delivery_dining.5c18295d.svg";